function groupByKey<T extends { [K in keyof T]: T[K] }, K extends keyof T>(
  array: T[] = [],
  key: K
) {
  return array.reduce((groups, item) => {
    const value = item[key];

    (groups[value] ||= []).push(item);

    return groups;
  }, {} as Record<string, T[]>);
}

function createRange(start: number, end: number): number[] {
  return Array.from({ length: end - start + 1 }, (_, i) => i + start);
}

export { groupByKey, createRange };
